import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const BidderRegisterNewContactDialogTourConfig: AgTechTourConfig = {
    id: 'bidder-register-new-contact-dialog-tour',
    name: 'New Contact Tour',
    steps: [
        {
            targetId: 'bidder-new-contact-basics',
            title: 'Name and Bidder Number',
            description: 'Enter the contact name and the bidder number they will use in this sale.',
            position: 'bottom',
        },
        {
            targetId: 'bidder-new-contact-info',
            title: 'Contact Information',
            description: 'Optional ranch name, email and phone number.',
            position: 'bottom',
        },
        {
            targetId: 'bidder-new-contact-address',
            title: 'Address Information',
            description: 'The mailing address that will appear on invoices for this contact.',
            position: 'top',
        },
    ]
}
